module.exports = __webpack_public_path__ + "media/images/logos/University-of-London-2be64c64b23361546969e11b91d98dee.svg";